// extracted by mini-css-extract-plugin
module.exports = {"icon":"PeriodDropdown_icon__3tbac","popover":"PeriodDropdown_popover__3KGTw"};